'use strict'

module.exports =
  toHash: ->
    title: I18n.translate 'js.modules.browse.presenters.planner.title'
    subtitle: I18n.translate 'js.modules.browse.presenters.planner.subtitle'
